module.exports = __webpack_public_path__ + "static/media/Section 4 BG.cacc6e6a.png";